export const VERIFY_COMPANY_CODE_REQUEST = 'VERIFY_COMPANY_CODE_REQUEST';
export const VERIFY_COMPANY_CODE_SUCCESS = 'VERIFY_COMPANY_CODE_SUCCESS';
export const VERIFY_COMPANY_CODE_ERROR = 'VERIFY_COMPANY_CODE_ERROR';

export const GENERATE_TEMP_PASSWORD_REQUEST = 'GENERATE_TEMP_PASSWORD_REQUEST';
export const GENERATE_TEMP_PASSWORD_SUCCESS = 'GENERATE_TEMP_PASSWORD_SUCCESS';
export const GENERATE_TEMP_PASSWORD_ERROR = 'GENERATE_TEMP_PASSWORD_ERROR';

export const LOGIN_TEMP_PASSWORD_REQUEST = 'LOGIN_TEMP_PASSWORD_REQUEST';
export const LOGIN_TEMP_PASSWORD_SUCCESS = 'LOGIN_TEMP_PASSWORD_SUCCESS';
export const LOGIN_TEMP_PASSWORD_ERROR = 'LOGIN_TEMP_PASSWORD_ERROR';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';

export const SETUP_PROFILE_REQUEST = 'SETUP_PROFILE_REQUEST';
export const SETUP_PROFILE_SUCCESS = 'SETUP_PROFILE_SUCCESS';
export const SETUP_PROFILE_ERROR = 'SETUP_PROFILE_ERROR';

export const CREATE_PASSWORD_REQUEST = 'CREATE_PASSWORD_REQUEST';
export const CREATE_PASSWORD_SUCCESS = 'CREATE_PASSWORD_SUCCESS';
export const CREATE_PASSWORD_ERROR = 'CREATE_PASSWORD_ERROR';

export const RESET_ONBOARDING = 'RESET_ONBOARDING';

const block = {
  loading: false,
  success: false,
  error: null,
  data: null,
};

const initialState = {
  companyCodeVerification: { ...block },
  tempPasswordGeneration: { ...block },
  tempPasswordLogin: { ...block },
  passwordChange: { ...block },
  profileSetup: { ...block },
  createPassword: { ...block },
};

export const OnboardingReducer = (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_COMPANY_CODE_REQUEST:
      return { 
        ...state, 
        companyCodeVerification: { ...state.companyCodeVerification, loading: true, error: null } 
      };
    case VERIFY_COMPANY_CODE_SUCCESS:
      return {
        ...state,
        companyCodeVerification: { 
          ...state.companyCodeVerification, 
          loading: false, 
          success: true, 
          error: null,
          data: action.data
        },
      };
    case VERIFY_COMPANY_CODE_ERROR:
      return {
        ...state,
        companyCodeVerification: { 
          ...state.companyCodeVerification, 
          loading: false, 
          error: action.error 
        },
      };

    case GENERATE_TEMP_PASSWORD_REQUEST:
      return { 
        ...state, 
        tempPasswordGeneration: { ...state.tempPasswordGeneration, loading: true, error: null } 
      };
    case GENERATE_TEMP_PASSWORD_SUCCESS:
      return {
        ...state,
        tempPasswordGeneration: { 
          ...state.tempPasswordGeneration, 
          loading: false, 
          success: true, 
          error: null,
          data: action.data
        },
      };
    case GENERATE_TEMP_PASSWORD_ERROR:
      return {
        ...state,
        tempPasswordGeneration: { 
          ...state.tempPasswordGeneration, 
          loading: false, 
          error: action.error 
        },
      };

    case LOGIN_TEMP_PASSWORD_REQUEST:
      return { 
        ...state, 
        tempPasswordLogin: { ...state.tempPasswordLogin, loading: true, error: null } 
      };
    case LOGIN_TEMP_PASSWORD_SUCCESS:
      return {
        ...state,
        tempPasswordLogin: { 
          ...state.tempPasswordLogin, 
          loading: false, 
          success: true, 
          error: null,
          data: action.data
        },
      };
    case LOGIN_TEMP_PASSWORD_ERROR:
      return {
        ...state,
        tempPasswordLogin: { 
          ...state.tempPasswordLogin, 
          loading: false, 
          error: action.error 
        },
      };

    case CHANGE_PASSWORD_REQUEST:
      return { 
        ...state, 
        passwordChange: { ...state.passwordChange, loading: true, error: null } 
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        passwordChange: { 
          ...state.passwordChange, 
          loading: false, 
          success: true, 
          error: null,
          data: action.data
        },
      };
    case CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        passwordChange: { 
          ...state.passwordChange, 
          loading: false, 
          error: action.error 
        },
      };

    case SETUP_PROFILE_REQUEST:
      return { 
        ...state, 
        profileSetup: { ...state.profileSetup, loading: true, error: null } 
      };
    case SETUP_PROFILE_SUCCESS:
      return {
        ...state,
        profileSetup: { 
          ...state.profileSetup, 
          loading: false, 
          success: true, 
          error: null,
          data: action.data
        },
      };
    case SETUP_PROFILE_ERROR:
      return {
        ...state,
        profileSetup: { 
          ...state.profileSetup, 
          loading: false, 
          error: action.error 
        },
      };

    case CREATE_PASSWORD_REQUEST:
      return {
        ...state,
        createPassword: { 
          ...state.createPassword, 
          loading: true, 
          error: null 
        },
      };
    case CREATE_PASSWORD_SUCCESS:
      return {
        ...state,
        createPassword: { 
          ...state.createPassword, 
          loading: false, 
          success: true, 
          error: null,
          data: action.data
        },
      };
    case CREATE_PASSWORD_ERROR:
      return {
        ...state,
        createPassword: { 
          ...state.createPassword, 
          loading: false, 
          error: action.error 
        },
      };

    case RESET_ONBOARDING:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};


